import type { Action } from '../types';

interface ProgressState {
  show: boolean;
  percentageComplete: number;
  numComplete: number;
  maxValue: number;
}

const initialState = { show: false, percentageComplete: 0, numComplete: 0, maxValue: 0 };

export default function reducer(
  state: ProgressState = initialState,
  action: Action<any>,
): ProgressState {
  switch (action.type) {
    case 'progressData':
      return {...state, ...action.response};
    default:
      return state;
  }
}